/* global globals:false */
import React, { Component } from 'react';
import Pagination from 'react-js-pagination';
import get from 'lodash/get';
import ImagesMonitor from '../../components/image/ImagesMonitor';
import MonitorTopNav from '../../components/image/MonitorTopNav';

const apiWebroot = get(globals, 'apiWebroot', '/');

class ImagesMonitorContainer extends Component {
  state = {
    status: 'Loading images...',
    saving: false,
    images: null,
    activePage: 1,
    totalImagesCount: 0,
    perPage: 15,
    timeRange: '1-day',
    domain: 'All',
    thumbSize: 'o-l/',
    previewSize: 'o-n/',
  };

  fetchImages = this.fetchImages.bind(this);

  updateImagesContents = this.updateImagesContents.bind(this);

  updateImages = this.updateImages.bind(this);

  handlePageChange = this.handlePageChange.bind(this);

  changePerPage = this.changePerPage.bind(this);

  changeTimeRange = this.changeTimeRange.bind(this);

  changeDomain = this.changeDomain.bind(this);

  componentDidMount() {
    this.fetchImages();
  }

  handlePageChange(pageNumber) {
    this.setState({
      activePage: pageNumber,
      images: null,
      status: 'Loading images...',
    });
    this.fetchImages(pageNumber);
  }

  updateImages(update) {
    this.setState({ saving: true });
    const stateData = {
      images: null,
      saving: false,
    };
    const toDelete = [];
    const otherContents = [];

    update.forEach((img) => {
      if (img.content === 'abuse') {
        toDelete.push({ _id: img.id });
      } else {
        otherContents.push(img);
      }
    });

    if (toDelete.length) {
      const headers = {
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        Cache: 'no-cache',
      };

      const params = new URLSearchParams();
      params.append('_id', JSON.stringify(toDelete));
      params.append('response', 'json');

      fetch(`${get(globals, 'webroot', '/')}admin/images/abuse_batch`, {
        headers,
        method: 'POST',
        body: params,
        credentials: 'same-origin',
      })
        .then((data) => {
          if (data.status === 200) {
            if (otherContents.length) {
              this.updateImagesContents(otherContents);
            } else {
              stateData.status = 'Loading images...';
              stateData.activePage = 1;
              this.setState(stateData);
              this.fetchImages(1);
            }
          } else {
            stateData.status = data.status;
            this.setState(stateData);
          }
        })
        .catch((error) => {
          stateData.status = 'Image update failed';
          this.setState(stateData);
          console.log('Image update failed: ', error);
        });
    } else if (otherContents.length) {
      this.updateImagesContents(otherContents);
    } else {
      stateData.status = 'No image data to update';
      this.setState(stateData);
    }
  }

  updateImagesContents(update) {
    const stateData = {
      images: null,
      saving: false,
    };
    const body = JSON.stringify(update);
    fetch(`${apiWebroot}images/update`, {
      credentials: 'same-origin',
      method: 'POST',
      mode: 'same-origin',
      headers: {
        'content-length': body.length,
        'content-type': 'application/json',
      },
      body,
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.status === 'ok') {
          stateData.status = 'Loading images...';
          stateData.activePage = 1;
          this.setState(stateData);
          this.fetchImages(1);
        } else {
          stateData.status = data.status;
          this.setState(stateData);
        }
      })
      .catch((error) => {
        stateData.status = 'Image update failed';
        this.setState(stateData);
        console.log('Image update failed: ', error);
      });
  }

  fetchImages(activePageTarget, perPageTarget, timeRangeTarget, domainTarget) {
    let {
      activePage,
      perPage,
      timeRange,
      domain,
    } = this.state;

    if (activePageTarget) {
      activePage = activePageTarget;
    }
    if (perPageTarget) {
      perPage = perPageTarget;
    }
    if (timeRangeTarget) {
      timeRange = timeRangeTarget;
    }
    if (domainTarget) {
      domain = domainTarget;
    }

    const uB = 'images/monitor';
    const pP = '?page=';
    const lP = '&limit=';
    const tP = '&time=';
    const dP = '&domain=';

    const headers = {
      credentials: 'same-origin',
    };

    fetch(apiWebroot + uB + pP + activePage + lP + perPage + tP + timeRange + dP + domain, headers)
      .then((resp) => resp.json())
      .then((data) => {
        if (data.status === 'ok') {
          this.setState({
            images: data.images,
            status: 'Ready',
            totalImagesCount: data.total,
          });
        } else {
          this.setState({
            images: null,
            status: data.status,
            totalImagesCount: 0,
          });
        }
      })
      .catch((error) => {
        this.setState({
          images: null,
          status: 'Image fetch failed',
          totalImagesCount: 0,
        });
        console.log('Image fetch failed: ', error);
      });
  }

  changePerPage(e) {
    this.setState({
      perPage: Number(e.target.value),
      images: null,
      activePage: 1,
      status: 'Loading images...',
    });
    this.fetchImages(1, e.target.value);
  }

  changeTimeRange(e) {
    this.setState({
      timeRange: e.target.value,
      images: null,
      activePage: 1,
      status: 'Loading images...',
    });
    this.fetchImages(1, false, e.target.value);
  }

  changeDomain(e) {
    this.setState({
      domain: e.target.value,
      images: null,
      activePage: 1,
      status: 'Loading images...',
    });
    this.fetchImages(1, false, false, e.target.value);
  }

  render() {
    const {
      thumbSize,
      previewSize,
      status,
      images,
      saving,
      activePage,
      perPage,
      totalImagesCount,
      domain,
      timeRange,
    } = this.state;

    const { imagesBaseUri } = globals;

    const imageUrlBase = imagesBaseUri + thumbSize;
    const imagePreviewUrlBase = imagesBaseUri + previewSize;

    let content;
    let pagination = '';
    if (status === 'Ready') {
      content = (
        <ImagesMonitor
          images={images}
          save={this.updateImages}
          saving={saving}
          imageUrlBase={imageUrlBase}
          imagePreviewUrlBase={imagePreviewUrlBase}
        />
      );
      pagination = (
        <Pagination
          activePage={activePage}
          itemsCountPerPage={perPage}
          totalItemsCount={totalImagesCount}
          pageRangeDisplayed={5}
          onChange={this.handlePageChange}
        />
      );
    } else {
      content = <p className="mtl mbl">{status}</p>;
    }

    return (
      <div className="admin-monitor block group block--padded mbm">
        <MonitorTopNav
          changeDomain={this.changeDomain}
          domain={domain}
          changeTimeRange={this.changeTimeRange}
          timeRange={timeRange}
          totalImagesCount={totalImagesCount}
          changePerPage={this.changePerPage}
          perPage={perPage}
        />
        {content}
        {pagination}
      </div>
    );
  }
}

export default ImagesMonitorContainer;
